module.exports = __webpack_public_path__ + "static/media/EcstasyActive.a555ba6c.svg";